import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";

import { useCachedOrderRequestsApi } from "../../../../common/api/orders-api/useCachedOrderRequestsApi";
import { mapToOrderRequestDashboardItem, OrderRequestDashboardItem } from "../OrderRequestDashboardItem";

export const useOrderRequestDetails = () => {
    const { orderRequestId } = useParams<{ orderRequestId: string }>();
    const { getOrderRequestDetails } = useCachedOrderRequestsApi();
    const [orderRequest, setOrderRequest] = useState<OrderRequestDashboardItem>();
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true);
        getOrderRequestDetails({ orderRequestId })
            .then((response) => {
                const request = mapToOrderRequestDashboardItem(response.orderRequest);
                setOrderRequest(request);
            })
            .finally(() => {
                setIsLoading(false);
            });
    }, []);

    return { orderRequest, isLoading };
};
